import { render, staticRenderFns } from "./SignUpDialog.vue?vue&type=template&id=9ab92bcc&scoped=true"
import script from "./SignUpDialog.vue?vue&type=script&lang=ts"
export * from "./SignUpDialog.vue?vue&type=script&lang=ts"
import style0 from "./SignUpDialog.vue?vue&type=style&index=0&id=9ab92bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab92bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})
